import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    casinoAccents: string[];
  }
  interface ThemeOptions {
    casinoAccents?: string[];
  }
  interface Palette {
    facebook: Palette['primary'];
    google: Palette['primary'];
  }
  interface PaletteOptions {
    facebook?: PaletteOptions['primary'];
    google?: PaletteOptions['primary'];
  }
}

declare module '@mui/material' {
  interface ButtonPropsColorOverrides {
    facebook: true;
    google: true;
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: '"Arial", "Helvetica", sans-serif',
  },
  palette: {
    primary: {
      main: '#ef1b26',
      light: '#f56065',
      dark: '#b5111a',
      contrastText: '#fff',
    },
    secondary: {
      main: '#f86203',
      light: '#ff9a45',
      dark: '#bf4700',
      contrastText: '#fff',
    },
    success: {
      main: '#66bb6a',
      light: '#81c784',
      dark: '#388e3c',
    },
    warning: {
      main: '#ffa726',
      light: '#ffb74d',
      dark: '#f57c00',
    },
    info: {
      main: '#29b6f6',
      light: '#4fc3f7',
      dark: '#0288d1',
    },
    error: {
      main: '#f44336',
      light: '#e57373',
      dark: '#d32f2f',
    },
    facebook: {
      main: '#385499',
      light: '#314a86',
      dark: '#2a4074',
      contrastText: '#fff',
    },
    google: {
      main: '#fff',
      light: '#314a86',
      dark: '#f0f4ff',
      contrastText: '#0c0d0e',
    },
  },
  // Accent-bar colors for casino list rows. Curated warm palette so each row's
  // splash of identity harmonizes with the primary (red) and secondary (orange)
  // brand colors instead of using arbitrary hues.
  casinoAccents: [
    '#ef1b26', // brand red (primary)
    '#f86203', // brand orange (secondary)
    '#b5111a', // deep crimson
    '#e08a1e', // golden amber
    '#c2416b', // warm rose
    '#a33417', // rust
    '#bf4700', // burnt orange
    '#d84f2a', // coral
  ],
  //  components: {
  //    MuiButton: {
  //      styleOverrides: {
  //        textSecondary: {
  //          color: fontColor
  //        }
  //      }
  //    },
  //    MuiIconButton: {
  //      styleOverrides: {
  //        root: {
  //          height: "2em",
  //          width: "2em"
  //        }
  //      }
  //    },
  //    MuiInputBase: {
  //      styleOverrides: {
  //        input: {
  //          fontFamily: fontDefault
  //        }
  //      }
  //    },
  //    MuiInputLabel: {
  //      styleOverrides: {
  //        root: {
  //          fontFamily: fontDefault
  //        }
  //      }
  //    },
  //    MuiToolbar: {
  //      styleOverrides: {
  //        root: {
  //          '@media (min-width: 600px)': {
  //            padding: 0
  //          }
  //        }
  //      }
  //    },
  //    MuiTypography: {
  //      styleOverrides: {
  //        root: {
  //          fontFamily: fontDefault
  //        },
  //        h1: {
  //          color: fontColor,
  //          fontSize: "84px",
  //          fontWeight: "400"
  //        },
  //        h2: {
  //          fontSize: "40px",
  //          fontWeight: "100",
  //          opacity: "60%"
  //        },
  //        h3: {
  //          fontFamily: fontTitle,
  //          fontSize: "24px"
  //        },
  //        h4: {
  //          color: fontColor,
  //          fontFamily: fontTitle,
  //          fontSize: "24px",
  //          fontWeight: "600"
  //        },
  //        h5: {
  //          color: fontColor,
  //          fontWeight: "200"
  //        },
  //        h6: {
  //          color: fontColor,
  //          fontWeight: "200",
  //          fontSize: "14px"
  //        }
  //      }
  //    }
  //  }
});